export enum NavLink {
  HOME = '/',
  ABOUT = '/about',
  BLOG = '/blog',
  CV = '/cv',
  CONTACT = '/contact',
  PORTFOLIO = '/portfolio'
}

export const navLinks = [
  { label: 'About', route: NavLink.ABOUT },
  { label: 'Blog', route: NavLink.BLOG },
  { label: 'Portfolio', route: NavLink.PORTFOLIO },
  { label: 'Contact', route: NavLink.CONTACT },
  // { label: 'Articles', route: },
];